import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { colors, greys } from "@styles/color.styles";
import { fontFamilySans } from "@styles/type.styles";

const rowContainer: CSSProperties = {
  display: "inline-flex",
  position: "relative",
};

const carouselControls: CSSProperties = {
  display: "flex",
  position: "absolute",
  zIndex: 1,
  right: 132,
  bottom: -41,
};

const carouselPageContainer: CSSProperties = {
  display: "flex",
};

const carouselPageItem: CSSProperties = {
  paddingBottom: 6,
};

const tile: CSSProperties = {
  backgroundColor: "white",
  border: `2px solid ${greys.cloudyBlue}`,
  boxShadow: "0px 2px 4px rgba(148, 155, 172, 0.24)",
  borderRadius: 4,
  cursor: "pointer",
  opacity: 1,
  transition: "opacity 0.25s ease-in, color 0.1s ease-in, background-color 0.1s ease-in",

  "&:hover": {
    backgroundColor: greys.cloudyBlue,
  },
};

const mediumTile = Object.assign({}, tile, {
  boxSizing: "border-box",
  height: 63,
  width: 134,
  padding: "4px 10px",
});

const largeTile = Object.assign({}, tile, {
  padding: "10px 10px 9px",
  margin: "0px 8px 10px 4px",
  border: `2px solid ${greys.paleGrey}`,
  boxShadow: "0px 2px 4px rgba(148, 155, 172, 0.12)",
  lineHeight: "15px",
  fontFamily: fontFamilySans,
  fontSize: 13,
});

const mediumTileSelected = Object.assign({}, mediumTile, {
  backgroundColor: colors.green.darker,

  "&:hover": {},
});

const mediumTileMarginRight: CSSProperties = {
  marginRight: 10,
};

const largeTileSelected = Object.assign({}, largeTile, {
  backgroundColor: colors.green.darker,
});

const tileHeader: CSSProperties = {
  fontFamily: fontFamilySans,
  fontStyle: "normal",
  fontWeight: "bold",
  fontSize: 12,
  paddingBottom: 2,

  color: colors.green.darker,
};

const tileHeaderSelected = Object.assign({}, tileHeader, {
  color: "white",
});

const time: CSSProperties = {
  fontFamily: fontFamilySans,
  fontStyle: "normal",
  fontWeight: "bold",
  fontSize: 12,
  paddingBottom: 2,
  // lineHeight: 14,

  color: greys.dark,
};

const timeSelected = Object.assign({}, time, {
  color: "white",
});

const qualifier: CSSProperties = {
  fontFamily: fontFamilySans,
  fontStyle: "normal",
  fontWeight: "normal",
  fontSize: 12,

  color: greys.slate,

  "& > span": {
    fontFamily: fontFamilySans,
  },
};

const qualifierSelected = Object.assign({}, qualifier, {
  color: "white",
});

const noSuggestions: CSSProperties = {
  backgroundColor: greys.palePaleGrey,
  borderRadius: 4,
  fontSize: 13,
  letterSpacing: "-0.0025em",
  color: greys.slate,
  padding: 16,
};

const noSuggestionsHeader: CSSProperties = {
  fontSize: 14,
  color: greys.slate,
};

const noSuggestionsSubheader: CSSProperties = {
  fontSize: 13,
  paddingTop: 5,
  color: greys.blueGrey,
};

const availableDate: CSSProperties = {
  color: colors.green.darker,
  cursor: "pointer",
};

const tagIcon: CSSProperties = {
  marginRight: 4,
  marginLeft: -1,
  fontSize: 16,
  verticalAlign: "middle",
};

const meetingRoomRow: CSSProperties = {
  marginTop: 5,
  fontSize: 12,
  lineHeight: 1.4,
  color: greys.slate,
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
};

const meetingRoomIcon: CSSProperties = {
  height: 18,
  width: 18,
  marginRight: 6,
  display: "flex",
  flexShrink: 0,
  color: greys.slate,
};

const meetingRoomIconSelected = Object.assign({}, meetingRoomIcon, {
  color: "white",
});

const warningIcon = Object.assign({}, tagIcon, {
  fontSize: 13,
  paddingBottom: 2,
});

const smallFocusIcon = Object.assign({}, warningIcon, {
  paddingLeft: 1,
});

const tagText: CSSProperties = {
  verticalAlign: "middle",
};

const focusTime: CSSProperties = {
  fontWeight: "bold",
};

const focusTimeDark = Object.assign({}, focusTime, {
  color: greys.dark,
});

const hoverStuffUppper: CSSProperties = {
  padding: "7px 10px 2px",
};

const dateTime: CSSProperties = {
  fontSize: 14,
  lineHeight: "17px",
  padding: "3px 0px 4px",
};

const dateTimeLarge: CSSProperties = {
  fontSize: 14,
  lineHeight: "17px",
  padding: "4px 0px",
  color: colors.blueDusk.darker,
  fontWeight: "bold",
};

const hoverFocusTime: CSSProperties = {
  color: greys.slate,
  fontSize: 12,
  lineHeight: "13px",
  paddingTop: 1,
  paddingBottom: 6,
};

const focusTimeLargeTile: CSSProperties = {
  color: greys.slate,
  fontSize: 13,
  lineHeight: "13px",
  paddingTop: 4,
  paddingBottom: 2,
};

const impacts: CSSProperties = {
  background: greys.palePaleGrey,
  padding: "4px 10px 8px",
  minHeight: 14,
};

const impactStrings: CSSProperties = {
  color: colors.peach.darker,
  fontSize: 12,
  lineHeight: "13px",
  paddingBottom: 10,
};

const darkPeach: CSSProperties = {
  color: colors.peach.darker,
};

const impactsShort: CSSProperties = {
  color: greys.dark,
};

const impactsShortSelected = Object.assign(
  {},
  {
    color: "white",
  },
);

const seperator: CSSProperties = {
  marginTop: 8,
  height: 1,
  background: greys.slate,
  opacity: 0.2,
};

const logoFeedback: CSSProperties = {
  display: "block",
  padding: "3px 0px 1px",
  height: 12,
};

const logo: CSSProperties = {
  fill: greys.slate,
  style: {
    display: "block",
    float: "left",
    width: 66,
  } as CSSProperties,
};

const feedback: CSSProperties = {
  float: "right",
  fontStyle: "italic",
  fontSize: 11,
  color: greys.slate,
  paddingTop: 1,
};

const largeTilePains = {
  backgroundColor: greys.palePaleGrey,
  display: "flex",
  justifyContent: "space-between",
  color: greys.blueGrey,
  fontSize: 14,
  cursor: "pointer",
  padding: "5px 12px 7px",
  margin: "7px -10px -9px",
  borderBottomLeftRadius: 2,
  borderBottomRightRadius: 2,

  "& > svg": {
    marginLeft: "auto",
    color: greys.slate,
  },
};

const largeTilePainsSelected = Object.assign({}, largeTilePains, {
  backgroundColor: colors.green.darker,
});

const largeTileRoom: CSSProperties = {
  color: greys.slate,
  fontSize: 13,
  lineHeight: "13px",
  paddingTop: 2,
  paddingBottom: 2,
  display: "flex",
  alignItems: "center",
};

const largeTileRoomSelected = Object.assign({}, largeTileRoom, {
  color: "white",
});

export const styles = {
  rowContainer,
  carouselPageContainer,
  carouselControls,
  carouselPageItem,
  mediumTile,
  mediumTileSelected,
  mediumTileMarginRight,
  largeTile,
  largeTileSelected,
  tileHeader,
  tileHeaderSelected,
  time,
  timeSelected,
  qualifier,
  qualifierSelected,
  noSuggestions,
  noSuggestionsHeader,
  noSuggestionsSubheader,
  availableDate,
  tagIcon,
  meetingRoomRow,
  meetingRoomIcon,
  meetingRoomIconSelected,
  tagText,
  focusTime,
  focusTimeDark,
  hoverStuffUppper,
  dateTime,
  dateTimeLarge,
  hoverFocusTime,
  focusTimeLargeTile,
  largeTileRoom,
  largeTileRoomSelected,
  impacts,
  impactStrings,
  warningIcon,
  smallFocusIcon,
  impactsShort,
  impactsShortSelected,
  darkPeach,
  seperator,
  logoFeedback,
  logo,
  feedback,
  largeTilePains,
  largeTilePainsSelected,
};
